'use client';

import { cn } from '../../utils/css/cn';
import Link, { LinkProps } from '../link/Link';

const variantStyles = {
	primary: [
		'inline-flex items-center justify-center cursor-pointer',
		'text-white bg-takeda-dark-red-600',
		'border border-takeda-dark-red-600',
		'min-w-50 px-8 py-[13px]',
		'leading-5 font-medium uppercase text-center',

		'hover:bg-takeda-dark-red-800 hover:border-takeda-dark-red-800',
		'active:bg-takeda-dark-red-700 active:border-takeda-dark-red-700',
		'focus-visible:outline-takeda-dark-red-600 focus-visible:bg-takeda-dark-red-800 focus-visible:border-takeda-dark-red-800',
	],
	secondary: [
		'inline-flex items-center justify-center cursor-pointer',
		'text-takeda-dark-red-600 bg-white',
		'border border-takeda-dark-red-600',
		'min-w-50 px-8 py-[13px]',
		'leading-5 font-medium uppercase text-center',

		'hover:border-takeda-dark-red-800 hover:text-takeda-dark-red-800',
		'active:border-takeda-dark-red-700 active:text-takeda-dark-red-700',
		'focus-visible:text-takeda-dark-red-800 focus-visible:border-takeda-dark-red-800',

		'dark:text-white dark:border-white dark:bg-inherit',
		'dark:hover:text-white dark:hover:bg-takeda-medium-grey-800 dark:hover:border-takeda-medium-grey-800',
		'dark:active:bg-takeda-medium-grey-600 dark:active:border-takeda-medium-grey-600',
		'dark:focus-visible:outline-white dark:focus-visible:text-white dark:focus-visible:border-takeda-medium-grey-800 dark:focus-visible:bg-takeda-medium-grey-800',
	],
	text: [
		'inline-flex items-center justify-center cursor-pointer',
		'text-takeda-dark-red-600',
		'border border-transparent',
		'min-w-50 px-8 py-[13px]',
		'leading-5 font-medium uppercase text-center',

		'hover:border-b-takeda-dark-red-800 hover:text-takeda-dark-red-800',
		'active:text-takeda-dark-red-700',
		'focus-visible:outline-takeda-dark-red-600 focus-visible:text-takeda-dark-red-800',

		'dark:text-white',
		'dark:hover:text-white dark:hover:border-b-white',
		'dark:active:text-takeda-medium-grey-300 dark:active:border-b-takeda-medium-grey-300',
		'dark:focus-visible:outline-white dark:focus-visible:text-white',
	],
};

interface ButtonLinkProps extends LinkProps {
	variant?: keyof typeof variantStyles;
}
/**
 * ButtonLink is a component for rendering `a` elements which look like a button.
 * Based on next-intl/Link component
 */
export const ButtonLink = ({
	className,
	variant = 'primary',
	children,
	...props
}: ButtonLinkProps) => {
	return (
		<Link {...props} className={cn(variantStyles[variant], className)}>
			{children}
		</Link>
	);
};
